import React from 'react';
import {Link, matchPath} from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {Button} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {useSnackbar} from 'notistack';
import {useSideMenuStyles} from '../SideMenu/styles';
import {SaltusAny} from '../../utils/SaltusAny';

const MenuItem: React.FC<{
  pathname: string;
  icon: React.FC<{[key: string]: SaltusAny}>;
  label: string;
  href: string | null;
  disabled?: boolean;
  external?: boolean;
  boldFont?: boolean;
  errorMessage?: string | null;
  onClick?: () => any;
}> = ({
  href,
  icon: Icon,
  external,
  disabled = false,
  pathname,
  label,
  boldFont,
  errorMessage,
  onClick,
}) => {
  const classes = useSideMenuStyles();
  const active = matchPath(`${href?.split('?')[0]}/*`, pathname);
  const theme = useTheme();
  const {enqueueSnackbar} = useSnackbar();

  return (
    <ListItem
      disableGutters
      sx={{
        ...classes.item,
        ...(active ? classes.activeItem : {}),
      }}
    >
      <Button
        sx={classes.drawerLink}
        disabled={disabled}
        component={href ? Link : Button}
        key={href}
        to={href || undefined}
        onClick={(e: SaltusAny) => {
          if (onClick) {
            return onClick();
          }
          if (external) {
            if (!href || href === '') {
              enqueueSnackbar(errorMessage || 'Link not valid', {
                variant: 'error',
                autoHideDuration: null,
              });
              return;
            }
            window.open(href, '_blank');
            e.preventDefault();
            e.stopPropagation();
          }
        }}
        data-test={label}
        style={{
          width: '100%',
        }}
      >
        <ListItemIcon
          style={{
            minWidth: '16px', // wierd MUI stuff
            maxWidth: '16px',
            color: active ? theme.palette.secondary.main : 'inherit',
          }}
        >
          <Icon style={{fontSize: 16}} />
        </ListItemIcon>
        <div style={{width: '100%', paddingLeft: 10}}>
          <ListItemText
            primary={label}
            style={{margin: 0}}
            primaryTypographyProps={{
              style: {
                textAlign: 'left',
                paddingBottom: 0,
                fontWeight: active || boldFont ? 600 : 500,
                fontSize: 12,
                color: active ? theme.palette.secondary.main : 'inherit',
              },
            }}
          />
        </div>
      </Button>
    </ListItem>
  );
};

export default MenuItem;
